/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_CommentsInputs */

const en_inbound_field_comments = /** @type {(inputs: Inbound_Field_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments of the supplier`)
};

/**
* | output |
* | --- |
* | "Comments of the supplier" |
*
* @param {Inbound_Field_CommentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_comments = /** @type {((inputs?: Inbound_Field_CommentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_CommentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_comments(inputs)
});